import { getIcon } from "@dreambigger/design-system/src/utils";

type EditProps = {
  keyword?: string;
};

const handleClick = () => {
  window.location.pathname = window.location.pathname.replace("detail", "edit");
};

const EditButton = ({ keyword }: EditProps) => {
  return (
    <div
      className="flex justify-between br-1 pv-4 ph-5 subtleLift pointer"
      style={{ backgroundColor: "#dde6ff", color: "black" }}
      onClick={handleClick}
    >
      {/* Edit Your Event */}
      <div className="flex fwb f-4">
        <div className="mr-3" style={{ color: "#1f3b7e" }}>
          {getIcon("pencil", 1)}
        </div>
        <p className="mb-0">
          <span className="fwb" style={{ color: "#1f3b7e" }}>
            Edit
          </span>{" "}
          your {keyword?.toLowerCase() || "event"}
        </p>
      </div>
      {/* Lock Icon */}
      <div className="gray-7">{getIcon("lock", 1)}</div>
    </div>
  );
};

export default EditButton;
